import fp from 'lodash/fp';

import { lookupTableReducer, reducePath } from 'Modules/core/redux';

import { certificatesActionTypes as types } from './actions';
import { certificateFilters } from './filters';


const defaultState = fp.mapValues(fp.constant({
    available: null,
    error: null,
    selected: null,
}), certificateFilters);

const actionLookup = {
    [types.SET_LIST]: reducePath((state, available) => ({
        ...state,
        available,
    })),
    [types.SET_ERROR]: reducePath((state, error) => ({
        ...state,
        error,
    })),
    [types.SET_CERTIFICATE]: reducePath((state, { cert }) => ({
        ...state,
        selected: cert,
    })),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
